export default __webpack_public_path__ + "static/log-axis-1b1c9319ae8d3791d7eb994e120a658f.png";